/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import NegoActionStepper from "../../../components/Stepper/NegoActionStepper";
import { useDispatch, useSelector } from "react-redux";
import PreparationPage from "./PreparationPage";
import NegotiationRounds from "./NegotiationRoundsPage";
import FinalizationPage from "./FinalizationPage";
import "./PlanNegotiationActions.scss";
import { useEffect, useState } from "react";
import { RootState } from "../../../redux/Reducer";
import NewActionCard from "../../../components/NewActionCard/newActionCard";
import { getAISuggestionForActionCards, getNegotiationActionRelation } from "../../../redux/Action/Action";
import WarningMsgIcon from "../../../assets/Icons/WarningIcon.svg";

interface PlanNegotiationActionsrProps {
  currentStep: number;
  totalSteps: number;
  goToStep: any;
  onCardSelect: (roundName: string, selectedCards: any[]) => void;
}
interface DependencyMap {
  [key: string]: string;
}
const PlanNegotiationActions = ({
  goToStep,
  currentStep,
  totalSteps,
  onCardSelect,
}: PlanNegotiationActionsrProps) => {
  const [selectedActionsMap, setSelectedActionsMap] = useState<
    Record<string, any[]>
  >({
    Preparation: [],
    Finalization: [],
  });

  const [inputTexts, setInputTexts] = useState<{
    [RoundName: string]: { [cardId: string]: string };
  }>({});
  const [finalizationInputTexts, setFinalizationInputTexts] = useState<{
    [cardId: string]: string;
  }>({});
  const [selectedActionTilesMap, setSelectedActionTilesMap] = useState<any[]>([]);

  const dispatch = useDispatch();
  const basicDetailsData = useSelector(
    (state: RootState) => state.basicDetails
  );
  const powerPositionData = useSelector(
    (state: RootState) => state.powerPosition.powerPosition
  );
  const TargetValueData = useSelector(
          (state: RootState) => state.TargetValue.TargetValueData
      );
  const salesRepData = useSelector(
    (state: RootState) => state.salesRepClassification.classificationType
  );
  const selectedCards: any = useSelector(
    (state: RootState) => state.selectedActionTiles.SelectedActionTilesData
  );
  const negotiationActionRelation: any = useSelector(
    (state: RootState) => state.negotiationActions.negotiationActionRelation
  )
  useEffect(() => {
    dispatch(getNegotiationActionRelation());
  }, []);
  //const selectedCards: any = useSelector((state: RootState) => state.selectedActionTiles.SelectedActionTilesData)
  const [deselectedCardIds, setDeselectedCardIds] = useState<Set<string>>(new Set());
  const parentDependecyMap: DependencyMap = {};
  negotiationActionRelation.forEach((item: any) => {
    parentDependecyMap[item.negotiationActionID] = item.dependentActionID
  })

  const handleCardSelectRounds = (card: any) => {
    const RoundName = "Round" + currentStep;
    setSelectedActionsMap((prev) => ({ ...prev, [RoundName]: card }));
    setSelectedActionTilesMap(card);
    onCardSelect(RoundName, card);

  };
  const handleCardSelectPreparation = (card: any[]) => {
    setSelectedActionsMap((prev) => ({ ...prev, Preparation: card }));
    setSelectedActionTilesMap(card);
    onCardSelect("Preparation", card);

  };
  const handleCardSelectFinalization = (card: any) => {
    setSelectedActionsMap((prev) => ({ ...prev, Finalization: card }));
    setSelectedActionTilesMap(card);
    onCardSelect("Finalization", card);

  };
  useEffect(() => {
    if (currentStep === 0) {
      setSelectedActionTilesMap([...selectedActionsMap.Preparation]);
    } else if (currentStep <= totalSteps - 2) {
      const roundKey = "Round" + currentStep;
      setSelectedActionTilesMap([...(selectedActionsMap[roundKey] || [])]);
    } else if (currentStep === totalSteps - 1) {
      setSelectedActionTilesMap([...selectedActionsMap.Finalization]);
    }
  }, [currentStep, selectedActionsMap]);
  useEffect(() => {
    if (
      currentStep === 0 &&
      Object.keys(selectedCards).length > 0 &&
      selectedCards?.Preparation?.length > 0
    ) {
      setSelectedActionTilesMap([...selectedCards.Preparation]);
    } else if (
      currentStep <= totalSteps - 2 &&
      Object.keys(selectedCards).length > 0
    ) {
      let RoundName = "Round" + currentStep;
      if (selectedCards[RoundName] && selectedCards[RoundName].length > 0) {
        setSelectedActionTilesMap([...selectedCards[RoundName]]);
      } else {
        setSelectedActionTilesMap([]);
      }
    } else if (
      currentStep === totalSteps - 1 &&
      selectedCards?.Finalization?.length > 0
    ) {
      setSelectedActionTilesMap([...selectedCards.Finalization]);
    } else {
      setSelectedActionTilesMap([]);
    }
  }, [currentStep]);
  const [showAIRecommendation, setShowAIRecommendation] =
    useState<boolean>(false);
  const aiActionCardsData = useSelector(
    (state: RootState) => state.negotiationActions.aiActionCardsData
  );
  const handleAISuggestion = () => {
    let payload = {
      RequestSource: "NegotiationAction",
      Supplier: "",
      Category: "",
      PowerPosition: "",
      SalesRepNegotiationType: "",
      NegotiationActionStage: "",
      Rounds:TargetValueData.rounds
    };
    let basicDetails = basicDetailsData.basicDetailsData;
    basicDetailsData.catagoriesData.map((obj: any) => {
      if (obj?.value === basicDetails.categoryName) {
        payload.Category = obj?.name;
      }
    });
    basicDetailsData.suppliersData.map((obj: any) => {
      if (obj?.value === basicDetails.suppliers) {
        payload.Supplier = obj?.name;
      }
    });
    payload.PowerPosition = powerPositionData;
    payload.SalesRepNegotiationType = salesRepData;
    let negotiationStage;
    if(currentStep ===0){
      negotiationStage ="Preparation"
    }
    else if(currentStep <= totalSteps - 2){
      negotiationStage ="Round" + currentStep
    }
    else{
      negotiationStage="Finalization"
    }
    payload.NegotiationActionStage =negotiationStage;
    dispatch(getAISuggestionForActionCards(payload));
  };
  useEffect(() => {
    if (aiActionCardsData?.statusCode === 200) {
      setShowAIRecommendation(true);
    }
  }, [aiActionCardsData]);

  let NegotiationPage;
  if (currentStep === 0) {
    NegotiationPage = <div>
      <PreparationPage
        onCardSelect={handleCardSelectPreparation}
        setSelectedActionTilesMap={setSelectedActionTilesMap}
        selectedActionTilesMap={selectedActionTilesMap}
        ParentDependecyMap={parentDependecyMap}
        deselectedCardIds={deselectedCardIds}
        setDeselectedCardIds={setDeselectedCardIds}
      />
    </div>
  }
  else if (currentStep === totalSteps - 1) {
   NegotiationPage = <div>
      <FinalizationPage
        onCardSelect={handleCardSelectFinalization}
        setSelectedActionTilesMap={setSelectedActionTilesMap}
        selectedActionTilesMap={selectedActionTilesMap}
        cardInputText={finalizationInputTexts}
        setCardInputText={setFinalizationInputTexts}
      />
    </div>
  }
  else {
   NegotiationPage = <div>
      <NegotiationRounds
        onCardSelect={handleCardSelectRounds}
        setSelectedActionTilesMap={setSelectedActionTilesMap}
        selectedActionTilesMap={selectedActionTilesMap}
        RoundName={`Round` + currentStep}
        inputTexts={inputTexts}
        setInputText={setInputTexts}
        ParentDependecyMap={parentDependecyMap}
        deselectedCardIds={deselectedCardIds}
        setDeselectedCardIds={setDeselectedCardIds}
      />
    </div>
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center", gap: "5rem" }}>
        <NewActionCard></NewActionCard>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "10%",
            marginBottom: "10px",
          }}
        >
          <button className="AddAction-button" onClick={handleAISuggestion}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-magic"
              viewBox="0 0 16 16"
            >
              <path d="M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707zM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1zM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707zM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0z" />
            </svg>
            Review by AI
          </button>
        </div>
      </div>
      <div style={{ marginLeft: "7rem", marginRight: "7rem" }}>
        {showAIRecommendation && (
          <div className="row align-items-stretch ai-recommendation-text-box">
            <div className="col-md-1">
              <img
                src={WarningMsgIcon}
                width="40px"
                height="40px"
                alt="Warning icon"
              />
            </div>
            <div className="col-md-10 col-sm-12 ai-recommendation-content">
              {aiActionCardsData?.result ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: aiActionCardsData?.result?.response,
                  }}
                />
              ) : null}
            </div>
            <div className="col-md-1">
              <svg
                onClick={() => setShowAIRecommendation(false)}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#EA9516"
                className="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </div>
          </div>
        )}
      </div>
      <div className="second-stepper-label">
        <b>
          Please select the actions you plan to use to finalize the negotiation:
        </b>
      </div>
      <div>
        <NegoActionStepper
          currentStep={currentStep}
          goToStep={goToStep}
          totalSteps={totalSteps}
        />
      </div>
      {NegotiationPage}
      { }
    </div>
  );
};

export default PlanNegotiationActions;